export type FactVerdict = "谣言" | "属实" | "存疑";

export interface FactCheckItem {
  id: string;
  title: string;
  verdict: FactVerdict;
  category: string;
  date: string;
  summary: string;
  basis: string;
  caseId: string;
}

export const factVerdicts: Array<"全部" | FactVerdict> = ["全部", "谣言", "属实", "存疑"];

export const factChecks: FactCheckItem[] = [
  {
    id: "fc-001",
    title: "“某中学食堂使用过期食材”视频内容不实",
    verdict: "谣言",
    category: "食品安全",
    date: "2026-08-15",
    summary:
      "视频被指存在剪辑拼接与时间错位，被指“过期”的包装属于另一批未使用原料，相关批次抽样检测合格。",
    basis: "校方台账、监管部门抽样通报、第三方留样记录",
    caseId: "case-001",
  },
  {
    id: "fc-002",
    title: "“社区团购蔬菜集体涨价三成”说法不成立",
    verdict: "谣言",
    category: "生活消费",
    date: "2026-07-30",
    summary:
      "对比图中的价格来自不同日期与不同规格商品，抽样居民实际订单未见集体涨价。",
    basis: "平台价格记录、随机订单抽样",
    caseId: "case-002",
  },
  {
    id: "fc-003",
    title: "“网红打卡地全面收费”系对公示信息的误读",
    verdict: "谣言",
    category: "文旅出行",
    date: "2026-03-17",
    summary:
      "现场仅一处配套观景平台收取维护费用，主体区域仍免费开放，爆料截取了公示信息的一部分。",
    basis: "现场公示信息、走访记录",
    caseId: "case-008",
  },
  {
    id: "fc-004",
    title: "“小区连续停水停电三天”为旧信息修改日期后传播",
    verdict: "谣言",
    category: "社区生活",
    date: "2026-06-24",
    summary:
      "实际仅有一次约 4 小时的计划检修，截图中的“通知”为旧版本修改日期后重新传播。",
    basis: "物业检修通知、供水单位记录",
    caseId: "case-004",
  },
  {
    id: "fc-005",
    title: "“预约接种需点击短信链接缴费”属仿冒信息",
    verdict: "谣言",
    category: "公共服务",
    date: "2026-05-20",
    summary:
      "正规预约接种不通过陌生短信链接收费，截图中链接地址与官方渠道不一致。",
    basis: "官方渠道提醒、链接地址比对",
    caseId: "case-006",
  },
  {
    id: "fc-006",
    title: "“外卖骑手集体被欠薪”暂无法确认，仍在核实",
    verdict: "存疑",
    category: "劳动权益",
    date: "2026-09-06",
    summary:
      "现有材料仅包含局部录屏与聊天记录，尚不足以支持或推翻该说法，平台方核查仍在进行。",
    basis: "平台方初步说明、骑手与站点沟通记录",
    caseId: "case-005",
  },
  {
    id: "fc-007",
    title: "“多条公交线路大面积改线”与官方通告不符",
    verdict: "谣言",
    category: "交通出行",
    date: "2026-04-28",
    summary:
      "运营方通告显示仅两条线路的部分站点调整，传闻扩大了调整线路数量与范围。",
    basis: "运营方通告、通勤群截图比对",
    caseId: "case-007",
  },
  {
    id: "fc-008",
    title: "景区餐饮“天价收费”争议属实，经营方已公开点单记录",
    verdict: "属实",
    category: "文旅出行",
    date: "2026-07-18",
    summary:
      "争议集中在标价与结算是否一致，经营方已公开当日点单记录，属地部门已介入核实。",
    basis: "经营方公开记录、属地部门核实信息",
    caseId: "case-003",
  },
];

export const getFactCheckById = (id: string): FactCheckItem | undefined =>
  factChecks.find((item) => item.id === id);